var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 2 L 6 4 L 5 4 C 3.9069372 4 3 4.9069372 3 6 L 3 20 C 3 21.093063 3.9069372 22 5 22 L 19 22 C 20.093063 22 21 21.093063 21 20 L 21 6 C 21 4.9069372 20.093063 4 19 4 L 18 4 L 18 2 L 16 2 L 16 4 L 8 4 L 8 2 L 6 2 z M 5 9 L 19 9 L 19 20 L 5 20 L 5 9 z M 14.800781 11.300781 L 11.5 14.599609 L 9.6992188 12.800781 L 8.3007812 14.199219 L 11.5 17.400391 L 16.199219 12.699219 L 14.800781 11.300781 z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToday);
export default __webpack_public_path__ + "static/media/icon-today.c1b6ba7e22eda131e36ba9b5345f5cdc.svg";
export { ForwardRef as ReactComponent };